module.exports = __webpack_public_path__ + "Server-Unavailable-AzureCloudService.4c795ce554d90e77e5e1e785eacbb4b7.hashedasset.svg";